import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const NotificationOverview = lazy(() => import('./notification-overview/notification-overview'));
const NotificationDetail = lazy(() => import('./notification-detail/notification-detail.component'));

export function NotificationRoutes() {
    return (
        <Route path='notifications'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <NotificationOverview />
                    </AsyncComponent>
                }
            />
            <Route path=':notificationId'>
                <Route
                    index
                    path='detail'
                    element={
                        <AsyncComponent>
                            <NotificationDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}

export default NotificationRoutes;
